import { createSlice } from "@reduxjs/toolkit";

export const initialState ={
  bg:'transparent',tb:'transparent',bm:'transparent',
  bnu:'transparent',hp:'LightGray',
  ce:{b1:'#FFCDD2',b2:'#E1BEE7',b3:'#C5CAE9',b4:'#BBDEFB',b5:'#B2DFDB',
      b6:'#DCEDC8',b7:'#FFF9C4',b8:'#FFE0B2',b9:'#F8BBD0'},
  hx:{a1:'#B71C1C',b1:'#FF8A80',a2:'#4A148C',b2:'#EA80FC',
      a3:'#33691E',b3:'#CCFF90',a4:'#01579B',b4:'#80D8FF',
      a5:'#827717',b5:'#F4FF81',},
  tc:{jz:'#0000ff',hz:'#00bfff'}
};

const colorplate=createSlice({
  name:"colorplate",
  initialState,
  reducers:{
    setColorAll:(state,action)=>{
      const { bg, tb, bm, bnu, hp, ce, hx, tc } = action.payload;
      state.bg = bg;
      state.tb = tb;
      state.bm = bm;
      state.bnu = bnu;
      state.hp = hp;
      state.ce = ce;
      state.hx = hx;
      state.tc = tc
    },
    setColorCe:(state,action)=>{
      const {ce} = action.payload;
      state.ce = ce;
    },
    setColorHx:(state,action)=>{
      const {hx} = action.payload;
      state.hx = hx;
    },
    setColorTc:(state,action)=>{
      const {tc} = action.payload;
      state.tc = tc;
    }
  }
});

export const {setColorAll,setColorCe,setColorHx,setColorTc}=colorplate.actions
export default colorplate.reducer